var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from "react";
import GenericDetails, { EValueType, } from "@frameworks/shared-library/components/GenericDetails/GenericDetails";
import moment from "moment";
import LinkedSipCard from "@frameworks/salesjourney/components/Features/ActivityBook/RM_Orderbook/ManagePortfolio/MutualFundOrders/MandateOrders/LinkedSipCard";
import { EMutualFundFlow } from "../MutualFund";
import MandateCalendar from "@frameworks/shared-library/components/MandateCalendar/MandateCalendar/MandateCalendar";
import basicProfileDi from "@frameworks/web/components/features/BasicProfile/di/servicelocator";
import { EMandateStatuses } from "@frameworks/shared-library/components/OrderBookSideBar/OrderBookSidebarConstants";
var currentDate = new Date();
var year = currentDate.getFullYear();
var month = currentDate.toLocaleString("en-us", { month: "short" });
var firstDateOfMonth = "01 ".concat(month, " ").concat(year);
var MandateViewDetails = function (props) {
    var _a, _b;
    var _c = __read(useState(null), 2), mandateDetails = _c[0], setMandateDetails = _c[1];
    var _d = __read(useState([]), 2), genericDetailsProps = _d[0], setGenericDetailsProps = _d[1];
    var _e = __read(useState(false), 2), isShowLinkedSips = _e[0], setIsShowLinkedSips = _e[1];
    var _f = __read(useState(false), 2), showPopup = _f[0], setShowPopup = _f[1];
    var _g = __read(useState(new Map()), 2), dateAmountDict = _g[0], setDateAmountDict = _g[1];
    var toggleMandateCalendar = function () {
        setShowPopup(!showPopup);
    };
    var hanldeOnClickLinkedSips = function () {
        setIsShowLinkedSips(!isShowLinkedSips);
    };
    var handleOnClickBack = function () {
        props === null || props === void 0 ? void 0 : props.setIsViewDetailsMode(false);
        props === null || props === void 0 ? void 0 : props.setTOCFlow(EMutualFundFlow.MANDATE);
    };
    var triggerGetCalendarData = function (startDate, mandateId) {
        if (mandateId === void 0) { mandateId = mandateDetails.mandateId; }
        return __awaiter(void 0, void 0, void 0, function () {
            var mandateCalendarPayload, resp, calendarDayAmountMap_1, err_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        //  remove the below hard coded userId once data is available
                        if (!mandateDetails)
                            return [2 /*return*/];
                        mandateCalendarPayload = {
                            userId: props.clientDetails.clientCode,
                            stDt: startDate,
                            mandateId: mandateId,
                        };
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, basicProfileDi.basicProfile.mandateCalendarData(mandateCalendarPayload)];
                    case 2:
                        resp = _b.sent();
                        calendarDayAmountMap_1 = new Map();
                        (_a = resp.data) === null || _a === void 0 ? void 0 : _a.mandateBalance.map(function (item) {
                            var str_date = moment(item.monthDate).format("DD MMM YYYY");
                            calendarDayAmountMap_1.set(str_date, parseInt(item.balanceAmount));
                        });
                        setDateAmountDict(calendarDayAmountMap_1);
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _b.sent();
                        console.log("err", err_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    useEffect(function () {
        if (!mandateDetails)
            return;
        triggerGetCalendarData(firstDateOfMonth);
        var accountLastFourDigits = mandateDetails.accountNumber
            .split("")
            .slice(-4)
            .join("");
        var updatedCreatedOnDate = moment(mandateDetails.createdOn).format("DD MMM YYYY");
        var updatedValidity = moment(mandateDetails.expiryDate).format("DD MMM YYYY");
        var genericDetails = [
            {
                label: "Mandate ID",
                value: "".concat(mandateDetails.shortName, "-").concat(mandateDetails.mandateId),
            },
            {
                label: "Status",
                value: (React.createElement("div", { className: "status-container d-flex flex-column ".concat(mandateDetails.dpStatus !== EMandateStatuses.ACTIVE
                        ? "pending-status-container"
                        : "") },
                    React.createElement("div", { className: "status-wrapper d-flex align-items-center" },
                        React.createElement("span", { className: "dot" }),
                        React.createElement("span", { className: "status-text DMSanN_12_400" }, mandateDetails.dpStatus)))),
            },
            {
                label: "Bank",
                value: "".concat(mandateDetails.bankName, " *").concat(accountLastFourDigits),
            },
            {
                label: "Created on",
                value: updatedCreatedOnDate,
            },
            { label: "Validity", value: updatedValidity },
            {
                label: "Amount",
                value: mandateDetails.amount,
                valueType: EValueType.CURRENCY,
            },
        ];
        setGenericDetailsProps(genericDetails);
    }, [mandateDetails === null || mandateDetails === void 0 ? void 0 : mandateDetails.mandateId]);
    useEffect(function () {
        var selectedMandate = props.mandateList.find(function (mandate) {
            if (!props.temporaryViewMandateDetailsMandateId.current) {
                return mandate.mandateId === props.selectedMandateId;
            }
            else {
                return (mandate.mandateId ===
                    props.temporaryViewMandateDetailsMandateId.current);
            }
        });
        setMandateDetails(selectedMandate);
        return function () {
            props.temporaryViewMandateDetailsMandateId.current = null;
        };
    }, [
        props === null || props === void 0 ? void 0 : props.selectedMandateId,
        props.temporaryViewMandateDetailsMandateId.current,
    ]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "mandate-view-detail-container bg_white d-flex flex-column" },
            React.createElement("div", { className: "top-section" },
                React.createElement("div", { className: "d-flex align-items-center gap-2" },
                    React.createElement("i", { onClick: handleOnClickBack, className: "edel-icon-left-shortArrow hand_cursor switch-mandate-back-arrow" }),
                    React.createElement("span", { className: "DMSansNormal_20_400 marginR-7" }, "Mandate Detail")),
                React.createElement(GenericDetails, { details: genericDetailsProps }),
                ((_a = props === null || props === void 0 ? void 0 : props.linkedSipData) === null || _a === void 0 ? void 0 : _a.length) > 0 ? (React.createElement("div", { className: "d-flex flex-column" },
                    React.createElement("div", { tabIndex: 0, onClick: hanldeOnClickLinkedSips, className: "d-flex justify-content-center txt-han-blue DMSans_13_400 hand_cursor" },
                        "Linked SIPs",
                        React.createElement("i", { className: "align-content-center ".concat(isShowLinkedSips
                                ? "edel-icon-arrow-up-thin"
                                : "edel-icon-arrow-down") })))) : null),
            isShowLinkedSips && (React.createElement("div", { className: "linked-sips-list d-flex flex-column" }, (_b = props === null || props === void 0 ? void 0 : props.linkedSipData) === null || _b === void 0 ? void 0 : _b.map(function (sip, index) { return (React.createElement(LinkedSipCard, __assign({ key: "".concat(index, "-").concat(sip.trxDateTime) }, sip))); }))),
            React.createElement("div", { className: "calendar" },
                React.createElement("div", { className: "d-flex justify-content-between align-items-center w-100" },
                    React.createElement(MandateCalendar, { rightIcon: showPopup ? "edel-icon-arrow-up-thin" : "edel-icon-arrow-down", toggleMandateCalendar: toggleMandateCalendar, isMandateCalendarShow: showPopup, dateAmountDict: dateAmountDict, triggerGetCalendarData: triggerGetCalendarData }))))));
};
export default MandateViewDetails;
